import React from 'react';
import ReactDOM from 'react-dom';
// import App from './views/App';
import Routes from './routes';

// import registerServiceWorker from './registerServiceWorker';
import './styles/application.scss';

ReactDOM.render(<Routes />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/application.js